import { arrayOf, oneOf, shape, string } from 'prop-types'

import { ColdChainApiProvider } from '../../models/cold-chain/cold-chain-api-provider-enum'
import { doorPropType } from './door-prop-type'
import { configSetAssignmentPropType } from './config-set-assignment-prop-type'

/**
 * @typedef {Object} DoorStatusData
 * @property {ConfigSetAssignment} configSetAssignment
 * @property {Door[]} doors
 * @property {string} objectId
 * @property {string} provider
 */

export const doorStatusDataPropType = shape({
    configSetAssignment: configSetAssignmentPropType.isRequired,
    doors: arrayOf(doorPropType).isRequired,
    objectId: string.isRequired,
    provider: oneOf(Object.values(ColdChainApiProvider)).isRequired
})
